export default __webpack_public_path__ + "static/media/EI1-2.4df75176.jpg";